import React, { useContext, useEffect } from 'react';
import { Box, SxProps, Typography, useTheme } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { Accept, FileWithPath, useDropzone } from 'react-dropzone';
import { borderRadiusValues } from 'shared/lib/utils/uiConstants';
import { useGetDashColor } from './utils';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';

export default function DropboxInner({
  onDrop,
  areMultipleUploadsAllowed,
  sx,
  text = '',
  buttonText = 'Загрузить',
  icon,
  accept = {
    'image/*': ['.jpeg', '.jpg', '.png'],
  },
  triggerMode,
}: {
  onDrop: (acceptedFiles: FileWithPath[]) => void;
  areMultipleUploadsAllowed: boolean;
  sx?: SxProps;
  text?: string;
  buttonText?: string;
  icon?: React.ReactNode;
  accept?: Accept;
  triggerMode?: boolean;
}) {
  const theme = useTheme();
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const {
    inputRef,
    getRootProps,
    getInputProps,
    open,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept,
    onDrop,
    noClick: true,
    noKeyboard: true,
    multiple: areMultipleUploadsAllowed,
  });
  const dashColor = useGetDashColor(isDragAccept, isDragReject);

  useEffect(() => {
    if (inputRef.current && triggerMode) {
      inputRef.current.click();
    }
  }, [triggerMode]);

  return (
    <Box
      sx={{
        display: triggerMode ? 'none' : 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        paddingY: 5,
        px: 10,
        width: 1,
        border: `2px dashed ${dashColor}`,
        borderRadius: borderRadiusValues.medium,
        ...sx,
      }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: sp.s40,
          maxWidth: 470,
        }}
      >
        {icon}
        <Typography variant="f24" color={theme.palette.text.secondary}>
          {text}
        </Typography>
        <PrimaryButton
          variant="contained"
          type="button"
          onClick={open}
          sx={{
            minWidth: 275,
          }}
        >
          {buttonText}
        </PrimaryButton>
      </Box>
    </Box>
  );
}
